import { render, staticRenderFns } from "./ShoppingRetail.vue?vue&type=template&id=3b6caa7d"
import script from "./ShoppingRetail.vue?vue&type=script&lang=js"
export * from "./ShoppingRetail.vue?vue&type=script&lang=js"
import style0 from "./ShoppingRetail.vue?vue&type=style&index=0&id=3b6caa7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports